import { Suspense } from 'react';
import { Navigate, Outlet, generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { useTypedParams } from '@sorare/routing';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { NBA_PLAY_EVENTTYPE } from '@sorare/core/src/constants/__generated__/routes';

import { ImportLineup } from '@sorare/gameplay/src/components/importLineup/ImportLineup';
import { useLastVisitedEventType } from '@sorare/gameplay/src/hooks/useLastVisitedEventType';
import { getValidEventType } from '@sorare/gameplay/src/lib/so5';

import { LayoutParams } from './__generated__/routeParams';

const Relative = styled.div`
  position: relative;
  isolation: isolate;
`;

const PlayEventTypeLayout = () => {
  const { eventType } = useTypedParams<LayoutParams>();
  const { lastVisitedEventType, setLastVisitedEventType } =
    useLastVisitedEventType();
  const validEventType = getValidEventType(eventType).toLowerCase();

  // Make sure users on old routes are redirected to the new one
  if (eventType.toLowerCase() !== validEventType) {
    return (
      <Navigate
        to={generatePath(NBA_PLAY_EVENTTYPE, {
          eventType: validEventType,
        })}
      />
    );
  }

  if (lastVisitedEventType !== eventType) {
    setLastVisitedEventType(eventType);
  }

  return (
    <Relative>
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
        <ImportLineup />
      </Suspense>
    </Relative>
  );
};

export default PlayEventTypeLayout;
